import React from "react";
import { BsPlusSquare } from "react-icons/bs";
import { FiHome } from "react-icons/fi";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdPersonOutline } from "react-icons/md";
import { PiChatTeardropText } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { CreateCommunity } from "..";
import { useSelector } from "react-redux";

type CommunityFooterProps = {
  isRefetching?: () => void;
};
const CommunityFooter: React.FC<CommunityFooterProps> = ({ isRefetching }) => {
  const [active, setActive] = React.useState<string>("Home");
  const [openCreate, setopenCreate] = React.useState(false);
  const handleClose = () => {
    setopenCreate(false);
  };
  const handleActive = (pageName: any) => {
    setActive(pageName);
  };
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user.userDetails);
  const add = "+ad4e_nj";
  React.useMemo(() => {
    if (user.id === null) {
      navigate("/auth");
    }
    // else {
    //   idRef.current = `${user.id}${add}`;
    // }
  }, [navigate, user]);
  // const messagesRef2 = collection(db, "ecobookChat", `${user.id}`, "chats");
  // const getChat = query(messagesRef2, where("unreadMessages", ">", 0));
  // const [otherDetails, isLoading, feedError] = useCollection(getChat);

  // const getNotifications =
  //   otherDetails && otherDetails?.docs.map((doc) => ({ ...doc.data() }));

  return (
    <div className="lg:hidden h-[70px] px-3 flex justify-between items-center bg-white fixed bottom-[-1px] w-full font-Poppins text-[10px] font-normal">
      <div
        className={`flex-1 grid align-text-bottom justify-items-center cursor-pointer ${
          active === "Home" ? "text-midGreen" : "text-CoolGrey "
        }`}
        onClick={() => handleActive("Home")}
      >
        <Link to="/ecobook">
          <FiHome size={21} />
        </Link>
        Home
      </div>
      <Link
        to="/chat/e"
        className={`flex-1 grid align-text-bottom justify-items-center relative cursor-pointer ${
          active === "Chat" ? "text-midGreen" : "text-CoolGrey "
        }`}
        onClick={() => handleActive("Chat")}
      >
        <PiChatTeardropText size={23} />
        Chat
        {/* {!feedError &&
          getNotifications &&
          getNotifications.map((notification) => (
            <b className="bg-midGreen text-[#fff] min-w-[16px] h-4 rounded-full flex justify-center font-Poppins items-center text-[8px] md:sm:top-[2px] sm:right-14 -top-1 right-4 absolute">
              {isLoading && <p>.</p>}
              {notification.unreadMessages / 2}
            </b>
          ))} */}
      </Link>
      <div
        className={`flex-1 grid align-text-bottom justify-items-center text-[9px] cursor-pointer ${
          active === "Add" ? "text-midGreen" : "text-CoolGrey "
        }`}
        onClick={() => {
          handleActive("Add");
          setopenCreate(true);
        }}
      >
        <BsPlusSquare size={21} />
        <div className="w-full flex justify-center">Create</div>
        Community
      </div>

      <Link
        to="/ecobook/my-communities"
        className={`flex-1 grid align-text-bottom justify-items-center cursor-pointer ${
          active === "Community" ? "text-midGreen" : "text-CoolGrey "
        }`}
        onClick={() => handleActive("Community")}
      >
        <HiOutlineUserGroup size={23} />
        Community
      </Link>

      <Link
        to={`/ecobook/profile/${user.id}${add}`}
        className={`flex-1 grid align-text-bottom justify-items-center cursor-pointer ${
          active === "Profile" ? "text-midGreen" : "text-CoolGrey "
        }`}
        onClick={() => handleActive("Profile")}
      >
        <MdPersonOutline size={23} />
        Profile
      </Link>
      {active === "Add" && openCreate && (
        <CreateCommunity
          isRefetching={isRefetching}
          handleClose={handleClose}
        />
      )}
    </div>
  );
};

export default CommunityFooter;
